import './CommentFieldInput.style.less'

import {
  Button,
  Col,
  Mentions,
  Row,
  Spin,
  Upload,
  UploadProps,
  message,
} from 'antd'
import {
  CloseOutlined,
  DeleteFilled,
  PaperClipOutlined,
} from '@ant-design/icons'
import { get, join } from 'lodash'
import { useRef, useState } from 'react'

import LoadingSpinner from '@/screens/Order/components/LoadingComponent/LoadingSpinner'

import { useMutation, useQuery } from 'react-query'
import HttpRequest from '@/config/axios.config'
import { getCollaboratorsForTasks } from '@/screens/Order/Pages/Order.transform'
import { getUrlParams, isEmptyValue } from '@/utils/common'

const UPLOAD_ACCEPT = [
  '.doc,',
  '.docx,',
  'application/msword,',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,',
  'application/vnd.ms-excel,',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,',
  'application/pdf,',
  'image/*',
]

const FILE_TYPE_ACCEPT = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/pdf',
]

function CommentFieldInput(prop: {
  onClose: () => any
  data: any
  type?: 'new' | 'reply'
  taskId: string
  parentId?: string
  section: 'all' | 'byOrderId'
  onReload: () => any
  // onIntervalChange: () => number
}) {
  const { onClose, taskId, onReload } = prop

  const mentionRef: any = useRef()

  const { data: users } = useQuery('GET_COLLABORATOR', async () => {
    return await getCollaboratorsForTasks(
      getUrlParams('orderKey') ?? prop.data?.order?.id
    )
  })

  // CommentFieldDialogContext

  const _type = prop?.type ?? 'new'

  const [comment, setcomment] = useState(null)
  const [files, setfiles] = useState([])

  const [mentions, setmentions] = useState([])

  const _clearData = () => {
    setcomment(null)
    setmentions([])
    setfiles([])
  }

  // addCommentByTaskId
  const mutation = useMutation(
    (taskData: any) => {
      let _tempPayLoad = taskData
      if (prop?.parentId) {
        _tempPayLoad = {
          ...taskData,
          parent: prop?.parentId,
        }
      }
      return HttpRequest.post(`/comments/tasks/${taskId}`, _tempPayLoad)
    },
    {
      onSuccess: () => {
        _clearData()
        onReload()
      },
      onError: () => {},
    }
  )

  const uploadMutation = useMutation(
    'upload',
    (taskData: any) => {
      return HttpRequest.post(`/medias/multiple/comments`, taskData, {
        headers: {
          [`Content-Type`]: `multipart/form-data`,
        },
      }).then((resp) => {
        return get(resp, 'data.data', [])
      })
    },
    {
      onSuccess: (data) => {
        const _payload = {
          type: _type,
          json_value: {
            comment: comment,
            mentions: mentions,
            medias: [],
            files: data,
          },
        }
        mutation.mutate(_payload)
      },
      onError: () => {},
    }
  )

  const _postComment = async () => {
    const formData = new FormData()
    files.map((file) => {
      formData.append('files', file)
    })
    uploadMutation.mutate(formData)
    _clearData()
  }

  const uploadProps: UploadProps = {
    accept: join(UPLOAD_ACCEPT),
    onRemove: (file) => {
      const index = files.findIndex((item) => item.uid === file.uid)
      const newFileList = files.slice()

      if (index !== -1) newFileList.splice(index, 1)
      setfiles(newFileList)
    },
    onChange: (e) => {
      if (e.fileList.length) window.onbeforeunload = () => 'warning'
      else window.onbeforeunload = undefined
    },
    beforeUpload: (file) => {
      !(file.type.startsWith('image/') || FILE_TYPE_ACCEPT.includes(file.type))
        ? message.error(
            `${file.name} is not an Excel, Word, PDF, or Image file`
          )
        : setfiles([...files, file])
      return false
    },
    showUploadList: {
      showRemoveIcon: true,
      removeIcon: <DeleteFilled />,
    },
    fileList: files,
  }

  return (
    <div className="comment-field-input-container">
      {/* New Comment Custom */}
      <Spin
        indicator={<LoadingSpinner />}
        spinning={mutation.isLoading || uploadMutation.isLoading}
      >
        {true && (
          <div className={`wrap-new-comment`}>
            <div className="new-comment">
              <Row>
                <Col
                  flex="auto"
                  style={{ position: 'relative', maxHeight: '1000px' }}
                >
                  <Mentions
                    value={comment}
                    onChange={(e) => {
                      setcomment(e)
                    }}
                    placeholder="Add comment"
                    ref={mentionRef}
                    autoSize={{ minRows: 1, maxRows: 25 }}
                    className="mention-input"
                  >
                    {users?.map((user) => (
                      <Mentions.Option
                        key={user?.user?.id}
                        value={`${user?.user?.first_name}`}
                        className="antd-demo-dynamic-option"
                      >
                        <span
                          onClick={() => {
                            setmentions([...mentions, user?.user?.id])
                          }}
                        >
                          {user?.user?.first_name} {user?.user?.last_name}
                        </span>
                      </Mentions.Option>
                    ))}
                  </Mentions>
                  <CloseOutlined
                    className="cancel-comment-button"
                    onClick={onClose}
                  />
                </Col>
              </Row>

              <Row justify={'end'} align="middle">
                <div>
                  <Upload {...uploadProps} className="comment-upload">
                    <Button
                      className="dialog-default-button button-comment"
                      icon={<PaperClipOutlined />}
                      shape="round"
                      size="large"
                    />
                  </Upload>
                </div>

                <Button
                  className="dialog-default-button"
                  // shape="round"
                  // htmlType="submit"
                  size="large"
                  onClick={() => {
                    // if (!comment) return
                    _postComment()
                  }}
                  type="primary"
                >
                  Send
                </Button>
              </Row>
            </div>
          </div>
        )}
      </Spin>
    </div>
  )
}

export default CommentFieldInput
